// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"27dd98f8","488":"4d201857"}[chunkId] + ".chunk.js";
};